import getProcessedRichtext from "components/Paragraph/helpers/getProcessedRichtext";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent, useEffect, useState, createRef } from "react";
import styles from "./Accordion.module.scss";
import AccordionProps from "./AccordionProps.interface";

const Accordion:FunctionComponent<AccordionProps> = (props) => {
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const content = createRef<HTMLDivElement>();

    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState("0px");

    const isOpenClass = isOpen ? styles.is_open : undefined;

    useEffect(() => {
        if (content.current) {
            setHeight(!isOpen ? "0px" : `${content.current.scrollHeight}px`);
        }
    }, [isOpen, content]);

    const designVersion = props.design ? props.design.replace(/ /g, "_") : "Version_One";

    return (
        <div className={combineClasses(styles.wrapper, styles[designVersion])}>
            {/* Heading */}
            <button className={combineClasses(styles.header_button, isOpenClass)} onClick={() => setIsOpen(!isOpen)}>
                <h3 className={styles.heading}>{props.content.heading}</h3>
                { designVersion === "Version_One" ? (
                    <span className={combineClasses(styles.indicator, isOpenClass)}>
                        <span className={styles.line}/>
                        <span className={styles.line}/>
                    </span>
                ) : (
                    <span className={combineClasses(styles.indicator, isOpenClass)}>
                        <svg viewBox="0 0 16 16" className={styles.arrow}xmlns="http://www.w3.org/2000/svg"><path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"></path></svg>
                        <svg viewBox="0 0 1024 1024" className={styles.cross} xmlns="http://www.w3.org/2000/svg"><defs></defs><path d="M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z"></path><path d="M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z"></path></svg>
                    </span>
                )
                }
            </button>

            {/* Content */}
            <div className={combineClasses(styles.content, isOpenClass)} ref={content} style={{ maxHeight: `${height}` }}>
                {processedBodyText ? (
                    <div className={styles.text} dangerouslySetInnerHTML={processedBodyText}></div>
                ) : null}
            </div>
        </div>
    );
};

export default Accordion;
